// The Supplier certificate field's verdict on a directory hit — see iscc-backend's service.
import { addDays, formatISO, parseISO } from 'date-fns';

export const CERTIFICATE_STATES = Object.freeze({
  idle: 'idle',
  checking: 'checking',
  verified: 'verified',
  notFound: 'notFound',
  datesOutside: 'datesOutside',
});

// The directory omits Valid_Until on some rows; an ISCC certificate runs 365 days.
const VALIDITY_DAYS = 364;

const validUntil = (certificate) => {
  if (certificate.validTo) return certificate.validTo;
  if (!certificate.validFrom) return null;
  return formatISO(addDays(parseISO(certificate.validFrom), VALIDITY_DAYS), {
    representation: 'date',
  });
};

/**
 * A hit is already valid — the service searches valid certificates only — so all that is
 * left is whether the declaration falls inside its window. Both dates are ISO `YYYY-MM-DD`,
 * so the comparison is on strings and no timezone can shift a boundary day.
 */
export const resolveCertificateState = (certificate, dateOfIssuance) => {
  if (!certificate) return CERTIFICATE_STATES.notFound;
  const from = certificate.validFrom;
  const to = validUntil(certificate);
  // Nothing to check against: the directory row carries no window.
  if (!dateOfIssuance || !from || !to) return CERTIFICATE_STATES.verified;
  return dateOfIssuance >= from && dateOfIssuance <= to
    ? CERTIFICATE_STATES.verified
    : CERTIFICATE_STATES.datesOutside;
};
